window.initProductSliders = () => {
    const sliders = document.querySelectorAll('.block__product-slider:not(.swiper-initialized), .block__collection-tab:not(.swiper-initialized), .related-products-slider:not(.swiper-initialized)');

    sliders.forEach((slider) => {
        slider.classList.add('swiper-initialized');
        // Read slides per view from data attributes
        const desktopSlides = parseFloat(slider.getAttribute('data-desktop-slides')) || 4;
        const tabletSlides = parseFloat(slider.getAttribute('data-tablet-slides')) || 3;
        const mobileSlides = parseFloat(slider.getAttribute('data-mobile-slides')) || 1.5;

        // Isolate navigation buttons per slider instance
        const nextButton = slider.querySelector('.swiper-button-next');
        const prevButton = slider.querySelector('.swiper-button-prev');

        new Swiper(slider, {
            loop: false,
            simulateTouch: true, // Enables mouse dragging
            grabCursor: true,
            spaceBetween: 16, // Default space between slides
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                320: {
                    slidesPerView: mobileSlides,
                    spaceBetween: 10,
                },
                750: {
                    slidesPerView: tabletSlides,
                    spaceBetween: 10,
                },
                1299: {
                    slidesPerView: desktopSlides,
                    spaceBetween: 14,
                },
            },
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initProductSliders);
} else {
    window.initProductSliders();
}

// Re-initialize for Shopify theme editor when section loads
document.addEventListener('shopify:section:load', window.initProductSliders);

// Re-initialize when recommendations are loaded
document.addEventListener('recommendations:loaded', window.initProductSliders);
